module.exports = __webpack_public_path__ + "static/media/imgCanvasLean.09d77638.svg";